/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../../_helpers'
import { unitTasksService } from '../../../_services/unitTasks.service'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import ConfirmDialog from '../../Shared/ConfirmDialog'
import { FaAngleLeft } from 'react-icons/fa'
import { AsyncUnitSelect } from '../../Shared/AsyncUnitSelect'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
import FormikCheckbox from '../../Shared/FormikCheckbox'

import { Formik, FieldArray, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../../Shared/ErrorPopUp'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import Step5 from './Step5'
import Step6 from './Step6'
import Step7 from './Step7'
import Step8 from './Step8'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

class Form extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      confirmDialogShow: false,
      loading: false,
      key: 'info',
      isModal: this.props.isModal,
      id: this.props.isModal ? this.props.id : this.props.match.params.id,
      taskType: this.props.isModal
        ? this.props.taskType
        : this.props.match.params.taskType,
      changeUnitModalShow: false,
      data: {
        unitId: '',
        taskId: '',
        description: '',
        items: [{ categoryId: '', brandId: '', productId: '', quantity: 0 }],
        outputs: [
          { categoryId: '', brandId: '', productId: '', quantity: 0, waste: 0 }
        ],

        shift: '',
        shiftManager: '',
        unitManager: '',
        techniciens: []
      }
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const { id } = this.state

    if (id) {
      this.setState({ loading: true })

      await unitTasksService
        .getByIdSPrum(id)
        .then(res => {
          let data = res.data

          data['lastDescription'] = data.description
          data['description'] = ''

          if (data.items && data.items.length>0) {
            let outputs = []
            data.items.forEach(item => {
              item['extraQuantity'] = 0
              item['subExtraQuantity'] = 0
              item['firstQuantity'] = item.quantity
              item['quantity'] = undefined
              item['subQuantity'] = undefined
              if (item.taskOperationProductType === 1) {
                item['waste'] = 0
                item['subWaste'] = 0
                outputs.push(item)
              }
            })

            data['items'] = data.items.filter(
              el => parseInt(el.taskOperationProductType, 0) === 0
            )
            data['outputs'] = outputs
          }

          data['shift'] = ''
          data['shiftManager'] = ''
          data['unitManager'] = ''
          data['qc'] = ''
          data['techniciens'] = []

          console.log(data)
          this.setState({ data: data, loading: false })
        })
        .catch(error => {
          // console.log(error);

          this.setState({ loading: false })
        })
    }
  }

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });

    let dto = {}
    dto['unitId'] = this.state.taskFinished == true ? undefined : values.unitId
    dto['taskId'] = this.state.data.taskId
    dto['previousUnitTaskId'] = this.state.data.id
    dto['taskFinished'] = this.state.taskFinished

    // let item = {};
    // item["productId"] = values.product.relatedProductId;
    // item["quantity"] = values.quantity;
    // item["waste"] = values.waste;
    // item["taskOperationProductType"] = 1;

    let items = values.items
    let outputs = values.outputs

    items.forEach(item => {
      item['taskOperationProductType'] = 0
      item['quantity'] = 0
    })

    // items.push(item);

    dto['items'] = items.concat(outputs)

    let personnels = []

    let techniciens = values.techniciens
    techniciens.forEach(item => {
      personnels.push({ personnelId: item, taskOperationPersonnelType: 0 })
    })

    personnels.push({
      personnelId: values.shiftManager,
      taskOperationPersonnelType: 1
    })
    personnels.push({
      personnelId: values.unitManager,
      taskOperationPersonnelType: 2
    })
    personnels.push({ personnelId: values.qc, taskOperationPersonnelType: 4 })

    dto['personnels'] = personnels

    dto['unitId'] = values.unitId
    dto['shift'] = values.shift
    dto['description'] = values.description
    dto['infos'] = values.infos

    console.log(dto)

    this.setState({ finalDto: dto }, () => {
      if (this.state.taskChangeUnitId) {
        this.handleChangeUnitModalShowConfirmDialog(true)
      } else if (this.state.materialReplacementRequest) {
        this.handleMaterialReplacementRequestModalShowConfirmDialog(true)
      } else {
        this.handleShowConfirmDialog(true)
      }
    })
  }

  handleChangeUnitModalShowConfirmDialog = val => {
    this.setState({ changeUnitModalShow: val })
  }

  handleMaterialReplacementRequestModalShowConfirmDialog = val => {
    this.setState({ materialReplacementRequestModalShow: val })
  }

  handleShowConfirmDialog = val => {
    this.setState({ confirmDialogShow: val })
  }

  handleSubmitAfterConfirm = () => {
    this.handleShowConfirmDialog(false)

    let finalDto = this.state.finalDto

    if (this.state.taskFinished) {
      finalDto['taskOperationType'] = 22
      this.setState({ taskFinishedLoading: true })
    } else if (this.state.taskChangeUnitId) {
      finalDto['taskOperationType'] = 25
      this.setState({ taskChangeUnitIdLoading: true })
    } else if (this.state.materialReplacementRequest) {
      finalDto['taskOperationType'] = 26
      this.setState({ materialReplacementRequestLoading: true })
    } else {
      finalDto['taskOperationType'] = 8
      this.setState({ taskSemiFinishedLoading: true })
    }

    console.log(JSON.stringify(finalDto))

    taskOperationsService
      .sprumAddTaskOperation(JSON.stringify(this.state.finalDto))
      .then(res => {
        console.log(res)

        this.setState({
          loading: false,
          taskFinishedLoading: false,
          taskSemiFinishedLoading: false
        })
        toastr.success('ثبت اطلاعات انجام شد')

        this.props.onSubmit()
      })
      .catch(error => {
        console.log(error)
        this.setState({
          loading: false,
          taskFinishedLoading: false,
          taskSemiFinishedLoading: false
        })
      })
  }

  handleChangeUnitId = values => {
    let finalDto = this.state.finalDto
    finalDto['newUnitId'] = values.newUnitId

    this.setState({ finalDto: finalDto }, () => {
      this.handleSubmitAfterConfirm()
    })
  }

  handleMaterialReplacementRequest = values => {
    let finalDto = this.state.finalDto
    // finalDto["taskOperationType"] = 26;

    this.setState({ finalDto: finalDto }, () => {
      this.handleSubmitAfterConfirm()
    })
  }

  render() {
    const {
      data,
      taskFinishedLoading,
      taskSemiFinishedLoading,
      taskChangeUnitIdLoading,
      changeUnitModalShow,
      materialReplacementRequestModalShow,
      materialReplacementRequestLoading
    } = this.state
    const itemsCount = data.items.length
    const outputsCount = data.outputs.length

    const item = Yup.object().shape({
      waste: Yup.number()
        .nullable()
        .min(0, 'مقدار ضایعات')
        .required('مقدار ضایعات')
      // productId: Yup.string().trim().nullable().required('محصول')
    })

    const output = Yup.object().shape({
      quantity: Yup.number()
        .nullable()
        .min(0, 'تعداد ورق پرس شده سالم')
        .required('تعداد ورق پرس شده سالم')
      // waste: Yup.number().nullable().min(0, 'مقدار ضایعات').required('مقدار ضایعات'),
    })

    const info = Yup.object().shape({
      value: Yup.string()
        .trim()
        .nullable()
        .required(' ')
    })

    const ValidationSchema = Yup.object().shape({
      unitId: Yup.string()
        .trim()
        .nullable()
        .required('واحد'),
      // quantity: Yup.string().trim().nullable().required('تعداد ورق پرس شده سالم'),
      // waste: Yup.string().trim().nullable().required('تعداد ضایعات'),
      items: Yup.array()
        .of(item)
        .min(itemsCount, 'تمامی اطلاعات')
        .required('تمامی اطلاعات محصول'),
      outputs: Yup.array()
        .of(output)
        .min(outputsCount, 'تمامی اطلاعات')
        .required('تمامی اطلاعات محصول'),

      shift: Yup.string()
        .trim()
        .nullable()
        .required('شیفت'),
      shiftManager: Yup.string()
        .trim()
        .nullable()
        .required('سرشیفت'),
      unitManager: Yup.string()
        .trim()
        .nullable()
        .required('مسئول پرس'),
      qc: Yup.string()
        .trim()
        .nullable()
        .required('کنترل کیفی'),
      techniciens: Yup.array()
        .of(Yup.string())
        .min(1, 'حداقل 1 اپراتور')
        .required('اپراتورهای پرس'),

      infos: Yup.array()
        .of(info)
        .min(data?.infos?.filter(e => e.required)?.length, 'اطلاعات تکمیلی')
        .required('اطلاعات تکمیلی')
    })
    return (
      <React.Fragment>
        <Formik
          enableReinitialize
          initialValues={data}
          onSubmit={(values, { setSubmitting }) => {
            // setSubmitting(true);
            this.handleSubmit(values)
            setSubmitting(false)
          }}
          validationSchema={ValidationSchema}>
          {props => {
            const {
              values,
              touched,
              errors,
              setFieldValue,
              setFieldTouched,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
              validateForm
            } = props
            return (
              <div>
                <div className="row" style={{ position: 'relative' }}>
                  <Fab
                    color="secondary"
                    aria-label="refresh"
                    size="small"
                    onClick={() => this.props.onClose()}
                    className="modal-close-btn absolute">
                    <MdClose size="20px" />
                  </Fab>
                  <form onSubmit={handleSubmit} id="form">
                    {/* <Tabs transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                  >

                    <Tab eventKey="info" title="اطلاعات فرآیند تولید"> */}
                    <div className="row">
                      <div className="col-lg-10 col-lg-offset-1">
                        <Step1 {...props} taskType={this.state.taskType} />
                        <Step5 {...props} taskType={this.state.taskType} />
                        <Step7 {...props} taskType={this.state.taskType} />
                        <Step2 {...props} taskType={this.state.taskType} />
                        <Step4 {...props} taskType={this.state.taskType} />
                        <Step8 {...props} taskType={this.state.taskType} />
                        <Step6 {...props} taskType={this.state.taskType} />
                        <Step3 {...props} taskType={this.state.taskType} />
                      </div>
                    </div>

                    <div className="col-lg-10 col-lg-offset-1">
                      <div className="row">
                        <div className="col-md-4 col-xs-5">
                          <button
                            type="submit"
                            className={
                              'btn btn-success btn-block btn-ripple btn-font-lg' +
                              (isSubmitting ? 'isSubmitting' : '')
                            }
                            disabled={
                              taskFinishedLoading ||
                              taskSemiFinishedLoading ||
                              taskChangeUnitIdLoading ||
                              materialReplacementRequestLoading ||
                              isSubmitting
                            }
                            onClick={e => {
                              e.preventDefault()
                              if (!isSubmitting && !taskFinishedLoading) {
                                this.setState(
                                  {
                                    taskFinished: true,
                                    dialogTitle: 'تایید تکمیل سفارش',
                                    dialogText:
                                      'آیا این سفارش بصورت کامل تمام شده است؟'
                                  },
                                  () => {
                                    handleSubmit()
                                  }
                                )
                              }
                            }}>
                            {taskFinishedLoading ? (
                              <AiOutlineLoading
                                className="mdi-spin"
                                size="22px"
                              />
                            ) : (
                              'سفارش بصورت کامل انجام شد'
                            )}
                          </button>
                        </div>
                        <div className="col-md-4 col-xs-5">
                          <button
                            type="submit"
                            className={
                              'btn btn-info btn-block btn-ripple btn-font-lg' +
                              (isSubmitting ? 'isSubmitting' : '')
                            }
                            disabled={
                              taskFinishedLoading ||
                              taskSemiFinishedLoading ||
                              taskChangeUnitIdLoading ||
                              materialReplacementRequestLoading
                            }
                            onClick={e => {
                              e.preventDefault()
                              console.log(errors)
                              console.log(values)
                              this.setState(
                                {
                                  taskFinished: false,
                                  dialogTitle:
                                    'تایید عدم اتمام کل سفارش در شیفت جاری',
                                  dialogText:
                                    'آیا این سفارش در شیفت جاری بصورت کامل تمام نشده و باید در شیفت بعدی ادامه یابد؟'
                                },
                                () => {
                                  // $(this).closest('form').submit()
                                  handleSubmit()
                                }
                              )
                            }}>
                            {taskSemiFinishedLoading ? (
                              <AiOutlineLoading
                                className="mdi-spin"
                                size="22px"
                              />
                            ) : (
                              'سفارش کامل نشده و در شیفت بعدی ادامه خواهد یافت'
                            )}
                          </button>
                        </div>
                        <div className="col-md-2 col-xs-2">
                          <button
                            type="submit"
                            className={
                              'btn btn-warning btn-block btn-ripple btn-font-lg' +
                              (isSubmitting ? 'isSubmitting' : '')
                            }
                            disabled={
                              taskFinishedLoading ||
                              taskSemiFinishedLoading ||
                              taskChangeUnitIdLoading ||
                              materialReplacementRequestLoading
                            }
                            onClick={e => {
                              e.preventDefault()
                              console.log(errors)
                              console.log(values)
                              this.setState(
                                {
                                  taskFinished: false,
                                  materialReplacementRequest: false,
                                  taskChangeUnitId: true
                                },
                                () => {
                                  // $(this).closest('form').submit()
                                  handleSubmit()
                                }
                              )
                            }}>
                            {taskChangeUnitIdLoading ? (
                              <AiOutlineLoading
                                className="mdi-spin"
                                size="22px"
                              />
                            ) : (
                              'تعویض دستگاه پرس'
                            )}
                          </button>
                        </div>
                        <div className="col-md-2 col-xs-2">
                          <button
                            type="submit"
                            className={
                              'btn btn-danger btn-block btn-ripple btn-font-lg' +
                              (isSubmitting ? 'isSubmitting' : '')
                            }
                            disabled={
                              taskFinishedLoading ||
                              taskSemiFinishedLoading ||
                              taskChangeUnitIdLoading ||
                              materialReplacementRequestLoading
                            }
                            onClick={e => {
                              e.preventDefault()
                              console.log(errors)
                              console.log(values)
                              this.setState(
                                {
                                  taskFinished: false,
                                  taskChangeUnitId: false,
                                  materialReplacementRequest: true
                                },
                                () => {
                                  // $(this).closest('form').submit()
                                  handleSubmit()
                                }
                              )
                            }}>
                            {materialReplacementRequestLoading ? (
                              <AiOutlineLoading
                                className="mdi-spin"
                                size="22px"
                              />
                            ) : (
                              'درخواست تغییر مواد اولیه'
                            )}
                          </button>
                        </div>
                        <div className="clearfix" />
                        <div className="clearfix" />
                        <div className="col-md-12">
                          <button
                            className={
                              'btn btn-default btn-block btn-ripple btn-font-lg' +
                              (isSubmitting ? 'isSubmitting' : '')
                            }
                            disabled={
                              taskFinishedLoading ||
                              taskSemiFinishedLoading ||
                              taskChangeUnitIdLoading ||
                              materialReplacementRequestLoading
                            }
                            onClick={e => {
                              e.preventDefault()
                              this.props.onClose()
                            }}>
                            بازگشت
                            <FaAngleLeft
                              style={{
                                verticalAlign: 'middle',
                                marginRight: 5
                              }}
                            />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* </Tab>
                    <Tab eventKey="materialsTab" title="مواد اولیه"> */}

                    {/* </Tab>

                  </Tabs> */}
                    {/* {JSON.stringify(values)} */}
                  </form>
                </div>

                <ConfirmDialog
                  open={this.state.confirmDialogShow}
                  onClose={() => this.handleShowConfirmDialog(false)}
                  onConfirm={() => this.handleSubmitAfterConfirm()}
                  title={this.state.dialogTitle}
                  text={this.state.dialogText}
                />
                {this.state.loading ? <Loading /> : ''}
              </div>
            )
          }}
        </Formik>

        <Dialog
          open={changeUnitModalShow}
          TransitionComponent={Transition}
          fullWidth={true}
          maxWidth="xs"
          onClose={() =>
            !taskChangeUnitIdLoading
              ? this.handleChangeUnitModalShowConfirmDialog(false)
              : ''
          }
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          // style={{ overflow: 'visible' }}
        >
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() =>
                !taskChangeUnitIdLoading
                  ? this.handleChangeUnitModalShowConfirmDialog(false)
                  : ''
              }
              className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
          </DialogTitle>
          <DialogContent className="search-modal">
            <Formik
              enableReinitialize
              initialValues={{ newUnitId: '' }}
              onSubmit={(values, { setSubmitting }) => {
                this.handleChangeUnitId(values)
                setSubmitting(false)
              }}
              validationSchema={Yup.object().shape({
                newUnitId: Yup.string()
                  .nullable()
                  .required('واحد جدید')
              })}>
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  resetForm
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        {/* {JSON.stringify(values)} */}

                        <div className="row">
                          <div className="form-inline search-container">
                            <div className="col-lg-12 col-sm-12">
                              <label>
                                انتخاب واحد جدید جهت تعویض دستگاه پرس
                              </label>

                              <AsyncUnitSelect
                                unitType="4"
                                // defaultValue={values.newUnitId}
                                name="newUnitId"
                                onChange={val => {
                                  setFieldValue('newUnitId', val)
                                }}
                                className={
                                  getIn(touched, 'newUnitId')
                                    ? getIn(errors, 'newUnitId')
                                      ? 'semantic-select-box has-error'
                                      : 'semantic-select-box'
                                    : 'semantic-select-box has-error'
                                }
                                exceptIds={
                                  this.state.finalDto
                                    ? [this.state.finalDto.unitId]
                                    : undefined
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="newUnitId"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                                disabled={
                                  isSubmitting || taskChangeUnitIdLoading
                                }>
                                {taskChangeUnitIdLoading ? (
                                  <AiOutlineLoading
                                    className="mdi-spin"
                                    size="22px"
                                  />
                                ) : (
                                  'تعویض دستگاه پرس'
                                )}
                              </button>
                              {/* <a className="btn btn-primary" 
      onClick={() => {
        setFieldValue('travelBrandId', undefined);
        resetForm({
          travelBrandId: undefined, transporterId: '', khodroId: '',
          cityId: '', originTerminalId: '', destinationCityId: '', destinationTerminalId: '', tripClass: '', price: ''
        })
        // console.log(values);

      }}
    >
      <i className="mdi mdi-playlist-check"></i>&nbsp;حذف همه فیلترها
    </a> */}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </DialogContent>
        </Dialog>

        <Dialog
          open={materialReplacementRequestModalShow}
          TransitionComponent={Transition}
          fullWidth={true}
          maxWidth="xs"
          onClose={() =>
            !materialReplacementRequestLoading
              ? this.handleMaterialReplacementRequestModalShowConfirmDialog(
                  false
                )
              : ''
          }
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          // style={{ overflow: 'visible' }}
        >
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() =>
                !materialReplacementRequestLoading
                  ? this.handleMaterialReplacementRequestModalShowConfirmDialog(
                      false
                    )
                  : ''
              }
              className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
          </DialogTitle>
          <DialogContent className="search-modal">
            <Formik
              enableReinitialize
              initialValues={{ confirm: false }}
              onSubmit={(values, { setSubmitting }) => {
                this.handleMaterialReplacementRequest(values)
                setSubmitting(false)
              }}
              validationSchema={Yup.object().shape({
                confirm: Yup.boolean().oneOf(
                  [true],
                  'لطفا درخواست خود را ﺗﺎﯾﯿﺪ نمائید'
                )
              })}>
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  resetForm
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        {/* {JSON.stringify(values)} */}

                        <div className="row">
                          <div className="form-inline search-container">
                            <div className="col-lg-12 col-sm-12">
                              <label className="text-center">
                                لطفا درخواست تعویض مواد اولیه را تائید نمایید
                              </label>

                              <Field
                                component={FormikCheckbox}
                                name="confirm"
                                id="confirm"
                                label={'تائید می کنم'}
                              />
                              {/* <span className="text-center">پس از ارسال درخواست، این سفارش موقتا تا زمان تعویض مواد اولیه توسط مدیر سایت، غیر فعال خواهد شد</span> */}
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="confirm"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                                disabled={
                                  isSubmitting ||
                                  materialReplacementRequestLoading ||
                                  taskChangeUnitIdLoading
                                }>
                                {taskChangeUnitIdLoading ? (
                                  <AiOutlineLoading
                                    className="mdi-spin"
                                    size="22px"
                                  />
                                ) : (
                                  'ارسال درخواست'
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    )
  }
}

export default Form
